import React from 'react';
import { XOutline } from 'icons';
import Toast from '../Toast';
import { ToastProps } from '../Toast';

export type ErrorToastProps = Pick<
  ToastProps,
  'heading' | 'subHeading' | 'className'
>;

const ErrorToast: React.FC<ErrorToastProps> = (props) => (
  <Toast icon={<XOutline />} accentColor="danger" {...props} />
);
export default ErrorToast;
